<script lang="ts">
    import { createEventDispatcher, onMount } from 'svelte'
    import { type Readable, derived as sderived, readable } from 'svelte/store'

    // import SimpleMDE from 'simplemde/src/js/simplemde'
    import EasyMDE from 'easymde/src/js/easymde'

    import type { HydriaDocument, IImage } from 'hydria/HydriaDocument'
    import { gettext as _ } from 'hydria/services/gettext'

    interface Props {
        Document?: HydriaDocument | null
        value?: string
    }

    let { Document = null, value = $bindable('') }: Props = $props()

    const previewName: string = 'admin'

    let images: Readable<IImage[]>

    if (Document) {
        images = sderived(Document.attachedImages, ($atts) => $atts)
    } else {
        images = readable([])
    }

    const dispatch = createEventDispatcher()

    const id = 'md' + '_' + Math.floor(Math.random() * 1000000000) + String(Date.now())

    let mdeElement: HTMLTextAreaElement | undefined = $state()

    let simplemde: any = $state()
    onMount(() => {
        simplemde = new EasyMDE({
            element: mdeElement,
            // Should be false, because we don't want font awesome.. but this editor
            // and it's predecessor SimpleMDE are based on this shit.
            autoDownloadFontAwesome: true,
            indentWithTabs: false,
            tabSize: 4,
            toolbar: [
                'bold',
                'italic', // 'strikethrough',
                'heading',
                '|', //'code',
                'quote',
                'unordered-list',
                'ordered-list',
                // 'clean-block',
                '|',
                // {
                //     name: 'attachment'
                //     action: (editor) ->
                //         $scope.chooseAttachments('smde', editor, 'markdown')
                //     className: 'fa fa-picture-o'
                //     title: Gettext.gettext('Insert link to files and images')
                //     // **FIXME** Sur version 2.0, on devrait pouvoir setter un shortcut
                //     // utiliser Cmd-Y
                // },
                // 'link', 'image',
                'table', // 'horizontal-rule',
                // '|', // **PREVIEW** ne marche pas pour l’immédiat, juste oublier le temps de passer à autre chose
                // 'preview',
                // 'side-by-side',
                // 'fullscreen',
                // '|',
                // {
                //     name: "guide",
                //     action: "/#/hydria-help/9593f60e-1bcc-4e4e-af21-92f921852284",
                //     className: "fa fa-question-circle",
                //     title: "Markdown Guide",
                //     default: true
                // },
                // 'undo', 'redo'
            ],
        })
        simplemde.codemirror.on('change', () => {
            value = simplemde.value()
            dispatch('update', value)
        })
    })

    function syncRevToMde(v: string) {
        const cv = simplemde.value()
        if (cv !== v) simplemde.value(v)
    }
    $effect(() => {
        if (simplemde) syncRevToMde(value)
    })
</script>

<!-- {#if showAttSelector}
    <AttachmentSelector
        attachments={Document.attachedFiles}
        editor={id}
        mode="codemirror"
        on:close={() => {
            showAttSelector = false
        }}
    />
{/if} -->

<div class="tt">
    [toolbar?]
    <div class="ed btn-site scheme scheme-display">
        <div class="simplemde">
            <textarea {id} bind:this={mdeElement} bind:value></textarea>
        </div>
    </div>
</div>
